// Environment Configuration Logic

interface Config {
    GRAPHQL_URI: string;
    COMPANY_SWITCH_URI: string;
    CDN_URL: string;
}

const configs: Record<string, Config> = {
    local: {
        GRAPHQL_URI: "http://localhost:4000/graphql",
        COMPANY_SWITCH_URI: "http://localhost:3005/login",
        CDN_URL: "dev-cdn.criticalasset.com",
    },
    development: {
        GRAPHQL_URI: "https://admin-dev.criticalasset.com/api",
        COMPANY_SWITCH_URI: "https://company-dev.criticalasset.com/login",
        CDN_URL: "dev-cdn.criticalasset.com",
    },
    staging: {
        GRAPHQL_URI: "https://admin-stg.criticalasset.com/api",
        COMPANY_SWITCH_URI: "https://company-stg.criticalasset.com/login", // Assumption based on pattern
        CDN_URL: "stg-cdn.criticalasset.com",
    },
    production: {
        GRAPHQL_URI: "https://admin.criticalasset.com/api",
        COMPANY_SWITCH_URI: "https://beta.criticalasset.com/login",
        CDN_URL: "cdn.criticalasset.com",
    },
};

const getConfig = (): Config => {
    const hostname = window.location.hostname;

    if (hostname === "localhost" || hostname === "127.0.0.1") {
        return configs.local;
    }

    if (hostname.includes("dev") || hostname.includes("development")) {
        return configs.development;
    }

    if (hostname.includes("stg") || hostname.includes("staging")) {
        return configs.staging;
    }

    return configs.production;
};

const currentConfig = getConfig();

export const GRAPHQL_URI = currentConfig.GRAPHQL_URI;
export const COMPANY_SWITCH_URI = currentConfig.COMPANY_SWITCH_URI;
export const CDN_URL = currentConfig.CDN_URL;

